import { useEffect, Dispatch } from 'react'
import { Actions, GbsAction } from '../store/actions'
import { GbsState, GbsStep } from '../store/interfaces'

export const useStep = (
  stepKey: keyof GbsState['steps'],
  stepConfig: Omit<GbsStep, 'data'>,
  dispatch: Dispatch<GbsAction>
) => {
  useEffect(() => {
    dispatch({
      type: Actions.InitializeStep,
      payload: {
        stepKey,
        stepConfig
      }
    })

    dispatch({ type: Actions.SetCurrentStep, payload: stepKey })
  }, [dispatch, stepKey, stepConfig])
}

export default useStep
